import React, { useEffect, useRef, useState } from "react";
import {
  ALPHABET_SPACE_PATTERN,
  INDIAN_MOBILE_NO_PATTERN,
} from "../../../utils/pattern";
import { IsStringNullEmptyOrUndefined } from "../../../utils/nullCheck";
import {
  checkValidInputOnKeyDown,
  IsFormValid,
  removeSpaceOnFirstCharacter,
} from "../../../utils/shared.service";
import { useDispatch } from "react-redux";
import {
  getCitiesStatesData,
  sendOTP,
  verifyOTP,
} from "../../../redux/homeSlice";
import { AppDispatch } from "../../../redux/store";
import uuid4 from "uuid4";
import { InputOtp } from "primereact/inputotp";
import { Toast } from "primereact/toast";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import Loader from "../../../components/loader";

function Quotation() {
  const location = useLocation();

  const { systemName } = location.state || {};

  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const { citiesStateData, isLoadingCitiesStateData, loading } = useSelector(
    (state: any) => state.home
  );

  const [stateName, setStateName] = useState("");

  const [showOTPModal, setShowOTPModal] = useState(false);

  const [token, setTokens] = useState<any>();

  const [storeUserDetails, setStoreUserDetails] = useState<any>({
    phoneNo: "",
    uuid: "",
    fullName: "",
  });

  const toast = useRef<Toast>(null);

  const fullNameInputRef = useRef<HTMLInputElement>(null);

  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  const [formValues, setFormValues] = useState({
    fullName: "",
    phoneNo: "",
    code: "",
    otp: "",
    uuid: "",
    cityName: "",
    stateName: "",
  });

  const [formErrors, setFormErrors] = useState({
    fullName: "Please enter full name",
    phoneNo: "Please enter phone no",
    cityName: "Please select city name",
  });

  useEffect(() => {
    fullNameInputRef.current?.focus();
  }, []);

  useEffect(() => {
    dispatch(getCitiesStatesData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (fieldName: string, value: any) => {
    switch (fieldName) {
      case "fullName": {
        const isValid: boolean = ALPHABET_SPACE_PATTERN.test(value);
        setFormErrors({
          ...formErrors,
          [fieldName]: IsStringNullEmptyOrUndefined(value)
            ? "Please enter full name"
            : !isValid
              ? "Please enter valid full name"
              : !IsStringNullEmptyOrUndefined(value) && value.length >= 3
                ? ""
                : "Minimum 3 characters are required",
        });
        break;
      }

      case "phoneNo": {
        const isValid: boolean = INDIAN_MOBILE_NO_PATTERN.test(value);
        setFormErrors({
          ...formErrors,
          [fieldName]: IsStringNullEmptyOrUndefined(value)
            ? "Please enter phone no"
            : !isValid
              ? "Please enter valid phone no"
              : !IsStringNullEmptyOrUndefined(value) && value.length >= 3
                ? ""
                : "Minimum 3 characters are required",
        });
        break;
      }

      case "cityName": {
        setFormErrors({
          ...formErrors,
          [fieldName]: IsStringNullEmptyOrUndefined(value)
            ? "Please select city name"
            : "",
        });
        break;
      }
      default:
        break;
    }
    setFormValues({
      ...formValues,
      [fieldName]: value,
    });
  };

  const sendOtp = () => {
    setIsFormSubmitted(true);

    const isValid = IsFormValid(formErrors);
    if (isValid) {
      setIsFormSubmitted(false);
      try {
        const reqObj: any = {
          fullName: formValues.fullName,
          phoneNo: formValues.phoneNo,
          cityName: formValues.cityName,
          stateName: stateName,
          code: "91",
          uuid: uuid4(),
        };
        dispatch(sendOTP(reqObj)).then((result) => {
          if (result.payload) {
            toast.current?.show({
              severity: "success",
              summary: "Success",
              detail: result.payload.message,
              life: 3000,
            });
            setStoreUserDetails({
              ...storeUserDetails,
              phoneNo: formValues.phoneNo,
              uuid: reqObj.uuid,
              fullName: formValues.fullName,
            });
            setShowOTPModal(true);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const verifyOtp = async () => {
    const reqobj = {
      phoneNo: storeUserDetails.phoneNo,
      otp: token,
      uuid: storeUserDetails.uuid,
    };
    try {
      const result = await dispatch(verifyOTP(reqobj));
      if (result.payload) {
        if (result.payload.statusCode === 200) {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: result.payload.message,
            life: 3000,
          });
          setFormValues({
            fullName: "",
            phoneNo: "",
            code: "",
            otp: "",
            uuid: "",
            stateName: "",
            cityName: "",
          });
          navigate("/get-quotation", {
            state: { systemName: systemName, uuid: storeUserDetails.uuid },
          });
          setShowOTPModal(false);
          setStoreUserDetails({
            phoneNo: "",
            uuid: "",
            fullName: "",
          });
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: result.payload.message,
            life: 3000,
          });
        }
      }
    } catch (error) { }
  };

  const resendOTP = () => {
    setTokens("");
    try {
      const reqObj: any = {
        fullName: storeUserDetails.fullName,
        phoneNo: storeUserDetails.phoneNo,
        code: "91",
        uuid: storeUserDetails.uuid,
      };
      dispatch(sendOTP(reqObj)).then((result) => {
        if (result.payload) {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: result.payload.message,
            life: 3000,
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeCitiesDDL = async (selectedCityName: any) => {
    const selectedCity = citiesStateData.find(
      (city: any) => city.cityName === selectedCityName
    );

    if (selectedCity) {
      setStateName(selectedCity.stateName); // Set the state name from the selected city
    } else {
      console.error("City not found in citiesStateData");
    }
  };

  return (
    <>
      <Loader isLoading={loading || isLoadingCitiesStateData} />
      <Toast ref={toast} position="bottom-center" />
      <section className="innerBannerWrapper">
        <img src="/assets/images/quotation-banner.webp" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="txt-white titleMain text-center">GET QUOTE NOW</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="quotationWrapper py-100">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <h2>GET QUOTE NOW</h2>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
              <div className="form-group">
                <input
                  ref={fullNameInputRef}
                  type="text"
                  className="form-control"
                  placeholder="Full name"
                  name="fullName"
                  maxLength={25}
                  value={formValues.fullName}
                  onChange={(e) => {
                    const trimmedValue = e.target.value.replace(/^\s+/g, "");
                    handleChange(e.target.name, trimmedValue);
                  }}
                  onKeyDown={(event: any) => {
                    checkValidInputOnKeyDown(event, ALPHABET_SPACE_PATTERN);
                    removeSpaceOnFirstCharacter(event);
                  }}
                />
                {isFormSubmitted && (
                  <small className="text-danger font-weight-500">
                    {formErrors.fullName}
                  </small>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
              <div className="form-group">
                <div className="input-group">
                  <span className="input-group-text">+91</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile"
                    name="phoneNo"
                    maxLength={10}
                    value={formValues.phoneNo}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      handleChange(e.target.name, value);
                    }}
                    onKeyDown={(event: any) => {
                      removeSpaceOnFirstCharacter(event);
                    }}
                  />
                </div>
                {isFormSubmitted && (
                  <small className="text-danger font-weight-500">
                    {formErrors.phoneNo}
                  </small>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
              <div className="form-group w-100">
                <Dropdown
                  value={formValues.cityName}
                  name="cityName"
                  options={citiesStateData}
                  onChange={(e) => {
                    onChangeCitiesDDL(e.target.value);
                    handleChange(e.target.name, e.target.value);
                  }}
                  optionLabel="cityName"
                  optionValue="cityName"
                  placeholder="City"
                  filter
                  className="w-100"
                  virtualScrollerOptions={{ itemSize: 38 }}
                />
                {isFormSubmitted && (
                  <small className="text-danger font-weight-500 mb-3">
                    {formErrors.cityName}
                  </small>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-4">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="State"
                  maxLength={25}
                  value={stateName}
                  disabled
                />
              </div>
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <button
                type="button"
                className="btn btn-black-border1"
                onClick={() => sendOtp()}
              >
                GET OTP
              </button>
            </div>
          </div>
        </div>
      </section>

      <div
        className={`modal fade otpWrapper ${showOTPModal ? "show" : ""}`}
        id="otpModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!showOTPModal}
        style={{ display: showOTPModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setShowOTPModal(false);
                  setTokens("");
                }}
              ></button>
            </div>
            <div className="modal-body">
              <h3>Please Enter the OTP to Verify your Account</h3>
              <p className="mb-5">
                A OTP (one time Password) has been sent to{" "}
                {storeUserDetails.phoneNo}
              </p>
              <div className="otpBox mb-5">
                <InputOtp
                  value={token}
                  onChange={(e: any) => setTokens(e.value)}
                  integerOnly
                  length={6}
                  className="form-control"
                />
              </div>

              <div className="mb-4">
                <button
                  className="btn btn-black-border1"
                  data-bs-dismiss="modal"
                  disabled={token?.length >= 6 ? false : true}
                  onClick={() => verifyOtp()}
                >
                  Get quote now
                </button>
              </div>
              <div className="mb-1">
                <div className="btn btn-link" onClick={() => resendOTP()}>
                  Resend OTP
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showOTPModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default Quotation;
